
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as map9QvxFsvg3FaBmOgpPTtU5R031sySsLQRYay1_zovF2UMeta } from "/home/docker/pages/v1/map.vue?macro=true";
import { default as ssoTunQ558Gb7cLWxRtVzTpYU0gCLqN_F27ROKKPqiYD2YMeta } from "/home/docker/pages/v1/sso.vue?macro=true";
import { default as cart6a82DS4twA8_45oG5du6K6RGRon8JWnM53C05JgrAC6okMeta } from "/home/docker/pages/v1/cart.vue?macro=true";
import { default as menuP48pKTBwaT6MpRs1qATFqHXAzjsq0vo1LPmx1K619d4Meta } from "/home/docker/pages/v1/menu.vue?macro=true";
import { default as indexYSL2x3xjW_3WgxOoSKePa8GKcYpiH9pmQ6LodAoH6m0Meta } from "/home/docker/pages/v1/index.vue?macro=true";
import { default as checkoutASexkVBQRZL_N_MbAa4hJisyi5XLmnvPBF7hQye04VMMeta } from "/home/docker/pages/v1/checkout.vue?macro=true";
import { default as v2lVTZ6QXxHL2_4535WH13_45Ad8_DxTaz_454it_45DpfrC5hzPYMeta } from "/home/docker/pages/v1/filter/v2.vue?macro=true";
import { default as termsL0dqpo_45FRYCaX7yHONWdURbToW3G8PP3W8pIC3tZLzsMeta } from "/home/docker/pages/v1/about/terms.vue?macro=true";
import { default as paymentjdt3xF9nUy0PpvwYBKhRdCpEco6Q9vsO0YVHVKCnAxcMeta } from "/home/docker/pages/v1/bfl/payment.vue?macro=true";
import { default as indexAVvrU_45iZfTL93SMdDfVvWRjFPO1XZOx3NEQi_45JrXcDsMeta } from "/home/docker/pages/v1/deals/index.vue?macro=true";
import { default as indexMPM39Zuyj8ymIKq6S_45l8CvaVkYw1V4uemDCBfWbZVSAMeta } from "/home/docker/pages/v1/loans/index.vue?macro=true";
import { default as _91id_930y_45P286M8xidoQddu9TzVyeeNEqqPwTHZvQIejgtpwoMeta } from "/home/docker/pages/v1/return/[id].vue?macro=true";
import { default as faq7Yx6kg_45_45_5mvHjYaclBeRz5873lcW3yQ5sSSPA7ZNmkMeta } from "/home/docker/pages/v1/support/faq.vue?macro=true";
import { default as callbackWAhUYEcUpE8zqUVIxG6SGAl6L_45nf76IrgIytYAad_45E4Meta } from "/home/docker/pages/v1/bfl/callback.vue?macro=true";
import { default as liveTrackingf9n9hTeDYWh2ZGegCTC0Ive2ckZ_456B00k0WT4habCsgMeta } from "/home/docker/pages/v1/liveTracking.vue?macro=true";
import { default as indexHcUeUYdo2slRNJ80DoAvmh_45orOr98LZInW4OsB_mnrwMeta } from "/home/docker/pages/v1/search/index.vue?macro=true";
import { default as aboutUs8ymBA6Hn_YGZqe_45CWuKMDgoOGNeykBlfZBkMGKG9VQgMeta } from "/home/docker/pages/v1/about/aboutUs.vue?macro=true";
import { default as v24Z54XfbJyZo6h9bJBrIwJglZbw_oSXJl65uSGFpm68UMeta } from "/home/docker/pages/v1/categories/v2.vue?macro=true";
import { default as login_45successKc3Lqc1JLdxFQQzd8oWzAjv61A1cFGW9pAYrJZ08MRwMeta } from "/home/docker/pages/v1/login-success.vue?macro=true";
import { default as order_45summaryZfpwik1Iv2eR46mConoBTwT05BZwrlAO2FluFel17E8Meta } from "/home/docker/pages/v1/order-summary.vue?macro=true";
import { default as _91id_93kUL3OaTeCxK5GikxSuxWcG5v8FcK22bZpzfVtm_tvV8Meta } from "/home/docker/pages/v1/products/[id].vue?macro=true";
import { default as store_45locatorBzwWHiN0NHiOZA7HHfZgueYLcIxwbYa3SusEy4lcRAYMeta } from "/home/docker/pages/v1/store-locator.vue?macro=true";
import { default as _91id_93fBJgWujrkIBAeHmlayRES_8uqOqqjZd0B3xy3CVmLycMeta } from "/home/docker/pages/v1/providers/[id].vue?macro=true";
import { default as profilen2aqJWJVKiF_45i8HgezgwkgWgHKcNpXuSbLYcWLZf5ZgMeta } from "/home/docker/pages/v1/account/profile.vue?macro=true";
import { default as location_45finder8xalE2kfNfMBMlmRqoHrW3j4lL14_45e4ioip6QdxSZ0wMeta } from "/home/docker/pages/v1/location-finder.vue?macro=true";
import { default as select_45locationea_45g1np2sIP_4oujfuubrW4vII4I9hl1l_45WIiYt_45yJ4Meta } from "/home/docker/pages/v1/select-location.vue?macro=true";
import { default as contactnMxA0K8m2pI8ODHWXqszBx3oGpR29Z4_45mHffnjrWVtMMeta } from "/home/docker/pages/v1/support/contact.vue?macro=true";
import { default as index_45yQn8oRf_WssTl9sTJ_4PyV9_457dSDobrv0xwBM2ezwMMeta } from "/home/docker/pages/v1/categories/index.vue?macro=true";
import { default as pmvkdxfljZOCtyBx4Qwggt5LaKOgH7nEc9v4_VjeVeyMc3EMeta } from "/home/docker/pages/v1/collections/pmvk.vue?macro=true";
import { default as SavedAddressFormBxxE2_45kCZOhncMyZFppCXs1Map3COcsK4p101d5QYRoMeta } from "/home/docker/pages/v1/SavedAddressForm.vue?macro=true";
import { default as addresseskVVF2NVI5y0_45MEqhmnc6Sa_VjYGc8PIkqLZKkI4pZjsMeta } from "/home/docker/pages/v1/account/addresses.vue?macro=true";
import { default as searchC7pMgDJnOZsr0xS_45JhXxtyY02vuzGHYvGmBRuTg2GPkMeta } from "/home/docker/pages/v1/categories/search.vue?macro=true";
import { default as indexnFcxO7wnqUoHr5Gi75ZyuACnajacws5dl_stOZ0nfMcMeta } from "/home/docker/pages/v1/finance/app/index.vue?macro=true";
import { default as offersgGt5r1IuQ01CIBngGJGJg_455NTxyzhMbSXLr3KXp_45h4gMeta } from "/home/docker/pages/v1/collections/offers.vue?macro=true";
import { default as _91id_93cvKznM_45PkZB_S0B9qiST3V3j5rovIsYgv8SqdtIhh1IMeta } from "/home/docker/pages/v1/account/orders/[id].vue?macro=true";
import { default as privacy_45policy_1sq89ZtWQ_vW_45DQlDXrseEhL3XNWYSBsvHdh4AIi6YMeta } from "/home/docker/pages/v1/about/privacy-policy.vue?macro=true";
import { default as indexLxXCfVJcsUQCwhVa5VzsSDgvEkRh2f0EV_hYDhLC4RkMeta } from "/home/docker/pages/v1/account/orders/index.vue?macro=true";
import { default as _91id_93ZZa16FYbE6YuXsnUuSDIVoNYD66bW2l9hQG8T0kR3NMMeta } from "/home/docker/pages/v1/account/tickets/[id].vue?macro=true";
import { default as search_45v2WlMskVDqQjfMC0ICt7sCi1UF7EajtGNyC4Ys7j4pcPkMeta } from "/home/docker/pages/v1/categories/search-v2.vue?macro=true";
import { default as index6Cf2Gz0AeQETIqeW3Blap8_45mOpSilQjcX3U7kl_45b3jAMeta } from "/home/docker/pages/v1/account/tickets/index.vue?macro=true";
import { default as giftcardsGlxICXQHSN1KkkIhRvwteeTr4diSjkUrg25Ixw4xU0AMeta } from "/home/docker/pages/v1/collections/giftcards.vue?macro=true";
import { default as mahakumbhdAudjz54eqoXRpDdHS6VOZpZ31Qd28mNUhPET_CzMBEMeta } from "/home/docker/pages/v1/collections/mahakumbh.vue?macro=true";
import { default as dashboardz_U6foIlt9_45vi2kPcaysAuIcMdMOVNe4IM7C2e8tCgkMeta } from "/home/docker/pages/v1/finance/app/dashboard.vue?macro=true";
import { default as raise_45requestgsjz_45aGE5TOO6topPfmQ6y0L3MzRe7fxUTdPep8MLJUMeta } from "/home/docker/pages/v1/support/raise-request.vue?macro=true";
import { default as mahakumbh1_OwWSb2ovJHK0C67V0_45QgSuabRO6JxMyXsl9EUYYRBAMeta } from "/home/docker/pages/v1/collections/mahakumbh1.vue?macro=true";
import { default as rebelfoodsPyPf56_45Z8AeAnN9PufjP6t_qcXqoo0fwmOHQ3mJJmlYMeta } from "/home/docker/pages/v1/collections/rebelfoods.vue?macro=true";
import { default as raise_a_requestpj7y_45Yxy81kh4D5U148TVPWma6eZRJ6K9OuzrzXQrowMeta } from "/home/docker/pages/v1/support/raise_a_request.vue?macro=true";
import { default as raise_45request_45pageyjaKmXH7MuWSe2b0QAHUiKTN2Snf0f3gbzyJ1NggGxoMeta } from "/home/docker/pages/v1/support/raise-request-page.vue?macro=true";
import { default as _91id_93llpY0wQ2BKknU2j9tPcHTzrPd1qq_45s7G2Xlu92jr14UMeta } from "/home/docker/pages/v1/collections/gift-cards/[id].vue?macro=true";
import { default as cartBHorwOzZdWlLcv5tpqa2HA_FrCOLIUn_45MPKU9FgCaOUMeta } from "/home/docker/pages/v1/collections/gift-cards/cart.vue?macro=true";
import { default as indexwKX8K61PUHgdz82YUiH1sEG06glnalg5rZdGo2IpYIgMeta } from "/home/docker/pages/v1/collections/kumbhcategories/index.vue?macro=true";
import { default as _91id_93_45sT4q9I7hmVaD46nOPS4DSZhiyHWSjtfHEfvz_45gkW6MMeta } from "/home/docker/pages/v1/collections/gift-cards/details/[id].vue?macro=true";
import { default as giftcardslistL2ZrvnJp8mua4magj_45gl41FlhpyZ0yTCwJf_j7bUh2YMeta } from "/home/docker/pages/v1/collections/gift-cards/giftcardslist.vue?macro=true";
import { default as giftcardslistNew3R7_Yrc26ggSAAp6FAAgW_45c95NhQBVDXdy4L3mMpOfkMeta } from "/home/docker/pages/v1/collections/gift-cards/giftcardslistNew.vue?macro=true";
import { default as _91id_93CqS92ZKz1SI69Da9wJwm4GHpM6RaXENTUvz_45qVh_EkgMeta } from "/home/docker/pages/v1/collections/gift-cards/order-summary/[id].vue?macro=true";
export default [
  {
    name: "map",
    path: "/map",
    component: () => import("/home/docker/pages/v1/map.vue")
  },
  {
    name: "sso",
    path: "/sso",
    component: () => import("/home/docker/pages/v1/sso.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cart6a82DS4twA8_45oG5du6K6RGRon8JWnM53C05JgrAC6okMeta || {},
    component: () => import("/home/docker/pages/v1/cart.vue")
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/home/docker/pages/v1/menu.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/docker/pages/v1/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/home/docker/pages/v1/checkout.vue")
  },
  {
    name: "filter-v2",
    path: "/filter/v2",
    component: () => import("/home/docker/pages/v1/filter/v2.vue")
  },
  {
    name: "about-terms",
    path: "/about/terms",
    component: () => import("/home/docker/pages/v1/about/terms.vue")
  },
  {
    name: "bfl-payment",
    path: "/bfl/payment",
    component: () => import("/home/docker/pages/v1/bfl/payment.vue")
  },
  {
    name: "DealsPage",
    path: "/deals",
    meta: indexAVvrU_45iZfTL93SMdDfVvWRjFPO1XZOx3NEQi_45JrXcDsMeta || {},
    component: () => import("/home/docker/pages/v1/deals/index.vue")
  },
  {
    name: "loans",
    path: "/loans",
    component: () => import("/home/docker/pages/v1/loans/index.vue")
  },
  {
    name: "return-id",
    path: "/return/:id()",
    component: () => import("/home/docker/pages/v1/return/[id].vue")
  },
  {
    name: "support-faq",
    path: "/support/faq",
    component: () => import("/home/docker/pages/v1/support/faq.vue")
  },
  {
    name: "bfl-callback",
    path: "/bfl/callback",
    component: () => import("/home/docker/pages/v1/bfl/callback.vue")
  },
  {
    name: "liveTracking",
    path: "/liveTracking",
    component: () => import("/home/docker/pages/v1/liveTracking.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/docker/pages/v1/search/index.vue")
  },
  {
    name: "about-aboutUs",
    path: "/about/aboutUs",
    component: () => import("/home/docker/pages/v1/about/aboutUs.vue")
  },
  {
    name: "CLPPageV2",
    path: "/categories/v2",
    meta: v24Z54XfbJyZo6h9bJBrIwJglZbw_oSXJl65uSGFpm68UMeta || {},
    component: () => import("/home/docker/pages/v1/categories/v2.vue")
  },
  {
    name: "login-success",
    path: "/login-success",
    component: () => import("/home/docker/pages/v1/login-success.vue")
  },
  {
    name: "order-summary",
    path: "/order-summary",
    component: () => import("/home/docker/pages/v1/order-summary.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/home/docker/pages/v1/products/[id].vue")
  },
  {
    name: "store-locator",
    path: "/store-locator",
    component: () => import("/home/docker/pages/v1/store-locator.vue")
  },
  {
    name: "ProviderPage",
    path: "/providers/:id()",
    meta: _91id_93fBJgWujrkIBAeHmlayRES_8uqOqqjZd0B3xy3CVmLycMeta || {},
    component: () => import("/home/docker/pages/v1/providers/[id].vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    component: () => import("/home/docker/pages/v1/account/profile.vue")
  },
  {
    name: "location-finder",
    path: "/location-finder",
    component: () => import("/home/docker/pages/v1/location-finder.vue")
  },
  {
    name: "select-location",
    path: "/select-location",
    component: () => import("/home/docker/pages/v1/select-location.vue")
  },
  {
    name: "support-contact",
    path: "/support/contact",
    component: () => import("/home/docker/pages/v1/support/contact.vue")
  },
  {
    name: "CLPPage",
    path: "/categories",
    meta: index_45yQn8oRf_WssTl9sTJ_4PyV9_457dSDobrv0xwBM2ezwMMeta || {},
    component: () => import("/home/docker/pages/v1/categories/index.vue")
  },
  {
    name: "collections-pmvk",
    path: "/collections/pmvk",
    component: () => import("/home/docker/pages/v1/collections/pmvk.vue")
  },
  {
    name: "SavedAddressForm",
    path: "/SavedAddressForm",
    component: () => import("/home/docker/pages/v1/SavedAddressForm.vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    component: () => import("/home/docker/pages/v1/account/addresses.vue")
  },
  {
    name: "SubCLPPage",
    path: "/categories/search",
    meta: searchC7pMgDJnOZsr0xS_45JhXxtyY02vuzGHYvGmBRuTg2GPkMeta || {},
    component: () => import("/home/docker/pages/v1/categories/search.vue")
  },
  {
    name: "finance-app",
    path: "/finance/app",
    component: () => import("/home/docker/pages/v1/finance/app/index.vue")
  },
  {
    name: "collections-offers",
    path: "/collections/offers",
    component: () => import("/home/docker/pages/v1/collections/offers.vue")
  },
  {
    name: "account-orders-id",
    path: "/account/orders/:id()",
    component: () => import("/home/docker/pages/v1/account/orders/[id].vue")
  },
  {
    name: "about-privacy-policy",
    path: "/about/privacy-policy",
    component: () => import("/home/docker/pages/v1/about/privacy-policy.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    component: () => import("/home/docker/pages/v1/account/orders/index.vue")
  },
  {
    name: "account-tickets-id",
    path: "/account/tickets/:id()",
    component: () => import("/home/docker/pages/v1/account/tickets/[id].vue")
  },
  {
    name: "NewSubCLPPage",
    path: "/categories/search-v2",
    meta: search_45v2WlMskVDqQjfMC0ICt7sCi1UF7EajtGNyC4Ys7j4pcPkMeta || {},
    component: () => import("/home/docker/pages/v1/categories/search-v2.vue")
  },
  {
    name: "account-tickets",
    path: "/account/tickets",
    component: () => import("/home/docker/pages/v1/account/tickets/index.vue")
  },
  {
    name: "collections-giftcards",
    path: "/collections/giftcards",
    component: () => import("/home/docker/pages/v1/collections/giftcards.vue")
  },
  {
    name: "collections-mahakumbh",
    path: "/collections/mahakumbh",
    component: () => import("/home/docker/pages/v1/collections/mahakumbh.vue")
  },
  {
    name: "finance-app-dashboard",
    path: "/finance/app/dashboard",
    meta: dashboardz_U6foIlt9_45vi2kPcaysAuIcMdMOVNe4IM7C2e8tCgkMeta || {},
    component: () => import("/home/docker/pages/v1/finance/app/dashboard.vue")
  },
  {
    name: "support-raise-request",
    path: "/support/raise-request",
    component: () => import("/home/docker/pages/v1/support/raise-request.vue")
  },
  {
    name: "collections-mahakumbh1",
    path: "/collections/mahakumbh1",
    component: () => import("/home/docker/pages/v1/collections/mahakumbh1.vue")
  },
  {
    name: "collections-rebelfoods",
    path: "/collections/rebelfoods",
    component: () => import("/home/docker/pages/v1/collections/rebelfoods.vue")
  },
  {
    name: "support-raise_a_request",
    path: "/support/raise_a_request",
    component: () => import("/home/docker/pages/v1/support/raise_a_request.vue")
  },
  {
    name: "support-raise-request-page",
    path: "/support/raise-request-page",
    component: () => import("/home/docker/pages/v1/support/raise-request-page.vue")
  },
  {
    name: "collections-gift-cards-id",
    path: "/collections/gift-cards/:id()",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/[id].vue")
  },
  {
    name: "collections-gift-cards-cart",
    path: "/collections/gift-cards/cart",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/cart.vue")
  },
  {
    name: "collections-kumbhcategories",
    path: "/collections/kumbhcategories",
    component: () => import("/home/docker/pages/v1/collections/kumbhcategories/index.vue")
  },
  {
    name: "collections-gift-cards-details-id",
    path: "/collections/gift-cards/details/:id()",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/details/[id].vue")
  },
  {
    name: "collections-gift-cards-giftcardslist",
    path: "/collections/gift-cards/giftcardslist",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/giftcardslist.vue")
  },
  {
    name: "collections-gift-cards-giftcardslistNew",
    path: "/collections/gift-cards/giftcardslistNew",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/giftcardslistNew.vue")
  },
  {
    name: "collections-gift-cards-order-summary-id",
    path: "/collections/gift-cards/order-summary/:id()",
    component: () => import("/home/docker/pages/v1/collections/gift-cards/order-summary/[id].vue")
  }
]